export interface TocItem {
  id: string;
  label: string;
  level: number;
}

const slugify = (s: string) =>
  s
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-");

/** Extract H2/H3 headings from markdown for the floating TOC. Slugs match rehype-slug defaults. */
export function buildTocFromMarkdown(md: string): TocItem[] {
  const items: TocItem[] = [];
  const lines = md.split("\n");
  let inFence = false;
  for (const line of lines) {
    if (/^```/.test(line)) {
      inFence = !inFence;
      continue;
    }
    if (inFence) continue;
    const m = /^(#{2,3})\s+(.+?)\s*$/.exec(line);
    if (m) {
      const level = m[1].length;
      const label = m[2].replace(/[*_`]/g, "");
      items.push({ id: slugify(label), label, level });
    }
  }
  return items;
}
